import { SNORKELING_IMAGES } from "@/config/constants";
import { memo } from "react";

export const SnorkelingSection = memo(({ sectionRef, isVisible }) => {
  const equipamentos = [
    { id: "equip-mascara", emoji: "🤿", text: "Máscara" },
    { id: "equip-snorkel", emoji: "🫧", text: "Snorkel" },
    { id: "equip-nadadeiras", emoji: "🦶", text: "Nadadeiras" },
    { id: "equip-neoprene", emoji: "🩱", text: "Roupa Neoprene" }
  ];

  return (
    <section 
      ref={sectionRef}
      className={`py-12 md:py-16 bg-gradient-to-b from-[#002776] to-[#001a4d] text-white transition-all duration-1000 ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'}`}
      data-testid="snorkeling-section"
    >
      <div className="max-w-7xl mx-auto px-4">
        <div className="text-center mb-10">
          <h2 className="font-heading text-3xl md:text-5xl text-white mb-4">
            NÃO SABE NADAR? <span className="text-[#FFDF00]">SEM PROBLEMAS.</span>
          </h2>
          <p className="text-lg text-white/90 max-w-2xl mx-auto mb-4">
            Você usa uma <strong className="text-[#FFDF00]">roupa de neoprene que faz seu corpo flutuar naturalmente</strong>.
          </p>
          <p className="text-base text-white/80 max-w-2xl mx-auto">
            Mesmo sem experiência, qualquer pessoa consegue aproveitar. Você pode entrar na água com total segurança, mesmo sendo iniciante.
          </p>
        </div>
        
        {/* Layout de fotos */}
        <div className="grid md:grid-cols-4 gap-4 mb-10">
          {SNORKELING_IMAGES.map((img, i) => (
            <div key={`snorkel-img-${i}`} className="relative group">
              <div className="rounded-2xl overflow-hidden shadow-xl aspect-[3/4]">
                <img 
                  src={img} 
                  alt={`Snorkeling ${i+1}`}
                  loading="lazy"
                  className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105" 
                />
              </div>
              {i === 0 && (
                <div className="absolute bottom-3 left-3 right-3 bg-white/90 backdrop-blur-sm rounded-lg p-2 shadow-lg">
                  <p className="text-[#002776] font-bold text-xs">Equipamento completo!</p>
                </div>
              )}
              {i === 1 && (
                <div className="absolute top-3 right-3 bg-[#009C3B] text-white rounded-full px-3 py-1 shadow-lg">
                  <span className="font-bold text-xs">Flutua!</span>
                </div>
              )}
              {i === 2 && (
                <div className="absolute bottom-3 left-3 right-3 bg-[#009C3B]/90 backdrop-blur-sm rounded-lg p-2 shadow-lg">
                  <p className="text-white font-bold text-xs">Tartarugas! 🐢</p>
                </div>
              )}
              {i === 3 && (
                <div className="absolute bottom-3 left-3 right-3 bg-[#FFDF00]/90 backdrop-blur-sm rounded-lg p-2 shadow-lg">
                  <p className="text-[#002776] font-bold text-xs">Estrelas do Mar! ⭐</p>
                </div>
              )}
            </div>
          ))}
        </div>
        
        {/* Equipamentos inclusos */}
        <div className="bg-white/10 backdrop-blur-sm border-2 border-[#FFDF00] rounded-3xl p-6 md:p-8 max-w-3xl mx-auto">
          <h4 className="font-bold text-white text-xl mb-4 text-center">Equipamentos inclusos no passeio:</h4>
          <div className="flex flex-wrap justify-center gap-3">
            {equipamentos.map((item) => (
              <div key={item.id} className="bg-white rounded-full px-5 py-3 shadow-lg hover:shadow-xl transition-shadow">
                <span className="font-semibold text-[#002776]">{item.emoji} {item.text}</span>
              </div>
            ))}
          </div>
          <p className="text-center text-white/80 mt-4 text-sm">
            Sempre escolhemos o <strong className="text-[#FFDF00]">melhor lugar</strong> para você aproveitar o snorkel e ver a vida marinha de pertinho!
          </p>
        </div>
      </div>
    </section>
  );
});

export default SnorkelingSection;
